<template>
  <div id="TopicBlock" class="top-block">
    <top-menu></top-menu>
    <div class="container top-block-content">
      <div class="row justify-content-center">
        <div class="col-11">
          <div class="block-content">
            <div class="row justify-content-left hide-in-mobile"
              v-if="getIsMobile == false">
              <div class="col-10 offset-1 col-sm-7 col-md-7 header-title">
                <div class="sprite">
                  <img v-if="false" :src="getImageSrc('header_title.png')" />
                  <div class="sprite-header_title"></div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center hide-not-mobile"
              v-if="getIsMobile == true">
              <div class="col-10 col-md-6">
                <div class="sprite text-center">
                  <img v-if="false" :src="getImageSrc('header_mtitle.png')" />
                  <div class="sprite-header_mtitle"></div>
                </div>
              </div>
            </div>
            <div class="row slogon first justify-content-center">
              <div class="col-10 col-md-10 col-lg-12">
                <p>本計畫依據「107-110 學年度中程校務發展計畫」</p>
                <p>進行數位課程製作與協助教師教學創新，並期達以下之願景</p>
              </div>
            </div>
            <!-- <div class="row slogon  justify-content-center">
              <div class="col-6 col-sm-9 col-md-10 col-lg-6">
                進行數位課程製作與協助教師教學創新，並期達以下之願景
              </div>
            </div> -->
            <div class="row sub-logo justify-content-center">
              <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-3 text-center">
                <div class="sprite-header_pic01"></div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 text-center">
                <div class="sprite-header_pic02"></div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 text-center">
                <div class="sprite-header_pic03"></div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 text-center">
                <div class="sprite-header_pic04"></div>
              </div> -->
              <div class="col-12 col-md-6 col-lg-3 text-center">
                <div class="title">
                  <number-badge text="1" size="26" class="number"></number-badge>
                  學校創新與特色發展
                </div>
                <div class="sprite-x">
                  <img :src="getImageSrc('header_mPic_01.png')" />
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 text-center">
                <div class="title">
                  <number-badge text="2" size="26" class="number"></number-badge>
                  協助教師教學與專業發展
                </div>
                <div class="sprite-x">
                  <img :src="getImageSrc('header_mPic_03.png')" />
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 text-center">
                <div class="title">
                  <number-badge text="3" size="26" class="number"></number-badge>
                  提升學習動機與成效
                </div>
                <div class="sprite-x">
                  <img :src="getImageSrc('header_mPic_04.png')" />
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 text-center">
                <div class="title">
                  <number-badge text="4" size="26" class="number"></number-badge>
                  發展延續至終身學習
                </div>
                <div class="sprite-x">
                  <img :src="getImageSrc('header_mPic_02.png')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import TopMenu from '@/components/Menu/TopMenu'
  import NumberBadge from '@/components/NumberBadge'
  // import { platformMixin, courseMixin } from './_Mixins'
  import { platformMixin, courseMixin } from '@/components/_Mixins'

  export default {
    // props: {
    //   'series_id': Number,
    //   'course_id': Number
    // },

    mounted() {
      // let result = this.getTopMenuForIndex('top-menu-index')
      // console.log('BlockWithTopMenu.vue', 'mounted()', 'result : ', result)

      // this.getTopMenuForIndex('top-menu-index')
      //   .then(result => {
      //     console.log('BlockWithTopMenu.vue', 'mounted()', 'result : ', result)
      //   })
    },

    components: {
      // 'top-menu': MenuComponents.TopMenu
      'top-menu': TopMenu,
      'number-badge': NumberBadge,
    },

    mixins: [ platformMixin, courseMixin ],

    methods: {
      ...mapActions([ 'getTopMenuForIndex' ]),

    },

    computed: {

    }
  }

</script>



// WEBPACK FOOTER //
// src/components/BlockWithTopMenu.vue